export const translations = {
  bg: {
    // Header translations
    home: 'Начало',
    tools: 'Инструменти',
    prices: 'Цени',
    about: 'За нас',
    contacts: 'Контакти',
    forTeachers: 'За преподаватели',
    gai: 'GAI',
    fieldBooks: 'Карнети',
    fieldBooksPilot: 'Пилот',
    account: 'Акаунт',
    login: 'Вход',
    logout: 'Изход',
    loading: 'Зареждане...',
    beta: 'BETA',

    // Footer translations
    quickLinks: 'Бързи връзки',
    privacyPolicy: 'Политика за поверителност',
    terms: 'Общи условия',
    disclaimer: 'Дисклеймър',
    socialNetworks: 'Социални мрежи',
    language: 'Български език',
    theme: 'Светъл режим',
    copyright: '© GEOSOLVER, 2025.\nВсички права запазени.\nТекуща версия: v4.0.0-beta.1',
    wortexaFooterBefore: 'е част от продуктовото семейство на ',
    wortexaFooterAfter: '',
    // FirstTask translations
    firstTaskTitle: 'Първа основна задача',
    firstTaskDescription: 'Изчисляване на координати по начална точка, ъгъл и дължина с онлайн геодезически калкулатор. Бързи и точни решения за геодезисти.',
    firstTaskKeywords: 'геодезия, онлайн калкулатор, първа основна задача, координати, ъгъл, дължина, трансформация, геодезически изчисления',
    secondTaskTitle: 'Втора основна задача',
    secondTaskDescription:
      'Изчисляване на разстояние и посочен ъгъл между две точки по координати с онлайн геодезически калкулатор.',
    secondTaskKeywords:
      'геодезия, втора основна задача, разстояние, посочен ъгъл, координати, геодезически калкулатор',
    secondTaskDefaultResultText:
      'Въведете координати и натиснете „Изчисли“, за да видите резултатите тук.',
    forwardIntersectionDescription:
      'Права засечка — определяне на координати на точка по две известни точки и ъгли с онлайн калкулатор.',
    forwardIntersectionKeywords:
      'геодезия, права засечка, триангулация, координати, геодезически калкулатор',
    resectionDescription:
      'Обратна засечка — определяне на позиция по насочени ъгли (по часовниковата стрелка) от три известни точки с онлайн калкулатор.',
    resectionKeywords:
      'геодезия, обратна засечка, насочени ъгли, координати, геодезически калкулатор',
    resectionDefaultResultText:
      'Въведете координатите на трите точки и двата насочени ъгъла (по часовниковата стрелка), след което натиснете „Изчисли“.',
    fillAllFields: 'Моля, попълнете всички полета.',
    enterX1Short: 'Въведете X₁',
    enterY1Short: 'Въведете Y₁',
    enterX2Short: 'Въведете X₂',
    enterY2Short: 'Въведете Y₂',
    docsFirstTaskSeoDescription:
      'Документация за първата основна геодезическа задача: теория, формули, таблица на знаците, проверка в GeoSolver и пример с числа.',
    docsFirstTaskSeoKeywords:
      'първа основна задача, документация, геодезия, формули, гради, координати, GeoSolver',
    docsSecondTaskSeoDescription:
      'Документация за втората основна задача: обратно изчисление на разстояние и посочен ъгъл между две точки, квадранти и проверка.',
    docsSecondTaskSeoKeywords:
      'втора основна задача, документация, обратна задача, разстояние, посочен ъгъл, GeoSolver',
    docsForwardIntersectionSeoDescription:
      'Документация за права засечка: синусова теорема, двойно определяне на точка P, ограничения за ъглите и пример.',
    docsForwardIntersectionSeoKeywords:
      'права засечка, документация, триангулация, геодезия, GeoSolver',
    docsResectionSeoDescription:
      'Документация за обратна засечка: три контролни точки, насочени ъгли по часовниковата стрелка в станция P, проверка на ъглите и условия за устойчивост.',
    docsResectionSeoKeywords:
      'обратна засечка, документация, насочени ъгли, опасна окръжност, геодезия, GeoSolver',
    inputData: 'Входни данни',
    results: 'Резултати',
    y1Coordinate: 'Y₁ (координата)',
    x1Coordinate: 'X₁ (координата)',
    angleAlpha: 'Ъгъл α (в гради)',
    lengthS: 'Дължина S',
    enterY1: 'Въведете координата Y1',
    enterX1: 'Въведете координата X1',
    enterAlpha: 'Въведете ъгъл α',
    enterS: 'Въведете дължина S',
    scan: 'Сканирай',
    reset: 'Нулирай',
    calculate: 'Изчисли',
    scanInDevelopment: 'Тази функция е в процес на разработка и интеграция.',
    defaultResultText: 'Въведете данни и натиснете "Изчисли", за да видите резултати тук.',
    calculationHistory: 'История на изчисленията',
    noCalculations: 'Няма изчисления.',
    date: 'Дата',
    download: 'Изтегли',
    documentation: 'Документация',
    instrument: 'Инструмент',
    back: 'Назад',
    next: 'Напред',

    // Homepage translations
    heroTitle: 'GeoSolver е проект, роден от желанието да се улесни ежедневната работа на геодезисти чрез достъпен онлайн инструмент. Платформата предоставя прецизни изчисления, интуитивен интерфейс и възможност за съхраняване на история на изчисленията.',
    heroSubtitle: 'Направете вашите геодезически изчисления бързо и лесно с нашите онлайн инструменти.',
    heroButton1: 'Започнете сега',
    heroButton2: 'Научете повече',

    // Tools page translations
    toolsTitle: 'Инструменти',
    toolsDescription: 'Инструменти за координатни изчисления, засечки, трансформации и площ в геодезията.',
    toolsInDevelopment: 'Инструменти в разработка',

    // Prices page translations
    pricesTitle: 'Цени и планове',
    pricesDescription: 'Използвайте GeoSolver безплатно с до 5 изчисления общо или изберете професионален абонамент за неограничен достъп и допълнителни функции.',
    month: 'Месец',
    year: 'Година (-20%)',
    freePlan: 'Безплатен план',
    proPlan: 'Професионален план',
    customPlan: 'Персонализиран план',
    basicAccess: 'Основен достъп до всички инструменти',
    fiveCalcsPerMonth: '5 изчисления общо',
    register: 'Регистрация',
    recommended: 'Препоръчано',
    unlimitedCalcs: 'Неограничени изчисления',
    prioritySupport: 'Приоритетна поддръжка',
    additionalFeatures: 'Допълнителни функции',
    subscribe: 'Абониране',
    customSolutions: 'Персонализирани решения',
    apiAccess: 'API достъп',
    contactUs: 'Свържи се с нас',
    faq: 'Често задавани въпроси',

    // FirstTaskDocs translations
    firstTaskDocsTitle: 'Първа основна задача при координатните изчисления',
    theory: 'Теория',
    theoryText: 'При много от геодезическите изчисления се използват две основни задачи, които се наричат първа и втора основна задача или права и обратна задача.',
    firstTaskDefinition: 'Първа основна задача е задача за определяне на координатите на точка B (XB, YB), когато са дадени координатите на точка A (XA, YA), дължината на отсечката SAB и посоченият ъгъл αAB (в гради).',
    given: 'Дадено:',
    givenPoints: [
      'YA, XA – координати на начална точка A',
      'SAB – дължина на отсечката AB',
      'αAB – посочен ъгъл (в гради, 0g ≤ α ≤ 400g)'
    ],
    lookingFor: 'Търси се:',
    lookingForPoints: ['YB, XB'],
    formulas: 'Формули',
    coordinateDifferences: 'ΔY и ΔX се наричат координатни разлики.',
    graphicalIllustration: 'Графична илюстрация',
    graphicCaption: 'Съгласно фиг. 21.1 координатите на т. B са:',
    signTable: 'Таблица за знаците',
    directionAngle: 'Посочен ъгъл',
    notes: 'Особености и бележки',
    notePoints: [
      'Посоченият ъгъл αAB може да бъде от 0 до 400g.',
      'Координатните разлики ΔYAB и ΔXAB се изчисляват чрез тригонометричните функции sin и cos за дадения ъгъл.',
      'Знаците на ΔYAB и ΔXAB се определят по таблицата по-горе.',
      'В електронните калкулатори често се използва директно формулата с тригонометричните функции.'
    ],
    example: 'Пример',

    // Account page translations
    accountTitle: 'Акаунт',
    accountDescription: 'Вашият GeoSolver акаунт, абонамент, история и настройки.',
    user: 'Потребител',
    logoutFromAccount: 'Излез от акаунта',
    settings: 'Настройки',
    settingsPanel: {
      title: 'Настройки',
      subtitle: 'Профил, изглед, сигурност и предпочитания',
      backToAccount: 'Обратно към акаунта',
      close: 'Затвори',
      sections: {
        profile: 'Профил',
        appearance: 'Изглед',
        security: 'Сигурност',
        preferences: 'Предпочитания',
        privacy: 'Поверителност',
      },
      profileDesc: 'Основна информация за акаунта ви в GeoSolver.',
      profileHint: 'За промяна на имейл или име пишете на team@geosolver.bg.',
      nameLabel: 'Име',
      emailLabel: 'Имейл',
      roleLabel: 'Роля',
      memberSince: 'Регистрация',
      appearanceDesc: 'Език на интерфейса и светла/тъмна тема.',
      languageLabel: 'Език',
      langBg: 'Български',
      langEn: 'English',
      themeLabel: 'Тема',
      themeLight: 'Светла',
      themeDark: 'Тъмна',
      securityDesc: 'Управление на паролата и достъпа до акаунта.',
      changePassword: 'Смяна на парола',
      currentPassword: 'Текуща парола',
      newPassword: 'Нова парола',
      confirmPassword: 'Повтори новата парола',
      savePassword: 'Запази паролата',
      saving: 'Запис...',
      passwordFillAll: 'Моля, попълнете всички полета.',
      passwordMismatch: 'Новите пароли не съвпадат.',
      passwordTooShort: 'Паролата трябва да е поне 6 символа.',
      passwordSuccess: 'Паролата е сменена успешно.',
      passwordFailed: 'Грешка при смяна на паролата.',
      forgotPasswordLink: 'Забравена парола?',
      googleSignInTitle: 'Вход с Google',
      googleSignInDesc: 'Акаунтът е свързан с Google. Смяна на парола не е налична — управлявайте достъпа от Google акаунта си.',
      preferencesDesc: 'Допълнителни опции за работа с платформата.',
      toolsInDevLabel: 'Инструменти в разработка',
      toolsInDevDesc: 'Показва в менюто инструменти, които още не са публично пуснати.',
      privacyDesc: 'Политики, бисквитки и правна информация.',
      cookieReset: 'Промени избора за бисквитки',
      cookieResetHint: 'Презарежда страницата',
    },
    professionalPlanMonthly: 'Професионален план (Месечен)',
    daysFromStart: 'дни от началото на плана Ви',
    daysToNext: 'дни до следващото плащане',
    changePlan: 'Промяна на плана',
    manageSubscription: 'Управление на абонамента',
    paymentMethods: 'Методи за плащане',
    remove: 'Премахни',
    addNewMethod: 'Добави нов метод',
    usageHistory: 'История на използване',
    calculations: 'изчисления',
    tool: 'Инструмент',
    paymentHistory: 'История на плащания',
    paymentMethod: 'Метод на плащане',
    value: 'Стойност',
    firstBasicTask: 'Първа основна задача',
    secondBasicTask: 'Втора основна задача',
    forwardIntersection: 'Права засечка',
    resection: 'Обратна засечка',
    polarIntersection: 'Полярна засечка',
    coordinateTransformation: 'Коорд. трансформация',
    hansenTask: 'Задача за ханзен',
    areaCalculation: 'Изчисляване на площ',
    distanceBearing: 'Разстояние и посока',
    
    // Checkout page translations
    checkoutTitle: 'Завършване на поръчката',
    checkoutSubtitle: 'Ще бъдете пренасочени към защитената платформа на Stripe за плащане',
    orderSummary: 'Резюме на поръчката',
    yearlyBilling: 'Годишно плащане',
    monthlyBilling: 'Месечно плащане',
    paymentDetails: 'Данни за плащане',
    cardNumber: 'Номер на карта',
    cardholderName: 'Име на притежателя',
    cardholderNamePlaceholder: 'Иван Иванов',
    expiryDate: 'Валидна до',
    completePayment: 'Завърши плащането',
    payWithStripe: 'Платете със Stripe',
    processingPayment: 'Обработва се...',
    securePaymentNotice: 'Вашите данни са защитени с 256-bit SSL криптиране',
    freePlanDefault: 'Безплатен план (По подразбиране)',
    freeCalculationsUntil: 'безплатни изчисления общо',
    viewPlans: 'Виж плановете',

    // Contacts page
    contactsTitle: 'Контакти',
    contactsDescription: 'Свържете се с екипа на Wortexa за въпроси относно GeoSolver — платформата, която разработваме и поддържаме.',
    contactIntro: 'На среща сме за всякакви въпроси.',
    contactEmail: 'team@geosolver.bg',
    emailLabel: 'Имейл',
    titleLabel: 'Заглавие',
    contentLabel: 'Съдържание',
    send: 'Изпрати',
    sending: 'Изпращане...',
    errorOccurred: 'Възникна грешка.',
    errorSending: 'Възникна грешка при изпращане.',
    connectionTimeout: 'Възникна таймаут. Моля, опитайте отново или пишете на team@geosolver.bg.',
    faqTitle: 'Често задавани въпроси',
    faqQuestions: [
      { question: 'Как се изчисляват безплатните изчисления?', answer: 'Всеки регистриран потребител получава общо 5 безплатни изчисления.' },
      { question: 'Какви видове изчисления поддържа GeoSolver?', answer: 'GeoSolver предлага координатни трансформации, изчисления на площ, дължина и обем, GNSS анализ и други инструменти.' },
      { question: 'Какви са начините за плащане?', answer: 'Приемаме плащания чрез кредитна/дебитна карта и PayPal.' },
      { question: 'Сигурни ли са моите данни?', answer: 'Всички данни се съхраняват криптирано и не се споделят с трети страни.' },
      { question: 'Как мога да се абонирам?', answer: 'Изберете професионален план и следвайте стъпките за плащане. След потвърждение ще имате неограничен достъп.' },
      { question: 'Има ли мобилна версия на GeoSolver?', answer: 'GeoSolver е направен специално за да се използва на малки устройства.' }
    ],

    // About page
    aboutPage: {
      seoTitle: 'За нас – GeoSolver',
      seoDescription:
        'GeoSolver — българска дигитална платформа за геодезически изчисления, разработвана и поддържана от екипа на Wortexa.',
      title: 'За нас',
      headline: 'Дигитална платформа за геодезия, образование и професионална практика',
      intro:
        'GeoSolver е български софтуерен продукт за онлайн геодезически изчисления. Развиваме инструменти за преподаватели, студенти и практикуващи геодезисти — с фокус върху точност, дигитализация и ефективност в ежедневната работа.',
      missionTitle: 'Мисия',
      missionText:
        'Да осигурим надеждна и достъпна дигитална среда за геодезически изчисления и обучение — съвместима с изискванията на учебния процес и на професионалната практика.',
      companyTitle: 'Разработка и поддръжка',
      companyTextBefore:
        'GeoSolver се разработва и поддържа от екипа на ',
      companyTextAfter:
        ' — компанията зад платформата. Имаме опит в инженерната геодезия, образованието и софтуерните продукти. Платформата интегрира калкулатори, класна стая за преподаватели и специализирани модули в единна облачна екосистема, достъпна от всяко устройство с браузър.',
      companyLinkLabel: 'Wortexa',
      focusTitle: 'Основни направления',
      focusAreas: [
        {
          title: 'Образование',
          desc: 'GeoSolver Edu предоставя на преподавателите класна стая, задания, автоматична проверка и управление на достъпа до калкулатора. Инструментите са съобразени с учебните програми по геодезия.',
        },
        {
          title: 'Дигитализация',
          desc: 'Преминаването към структурирани цифрови процеси намалява риска от грешки и подобрява проследимостта на изчисленията — в учебна среда и в професионална дейност.',
        },
        {
          title: 'Професионална практика',
          desc: 'Калкулаторите и модулите покриват стандартни геодезически задачи — от основни задачи и засечки до електронни карнети и специализирани инструменти.',
        },
        {
          title: 'Достъпност',
          desc: 'Безплатен план за запознаване с платформата, двуезичен интерфейс и ясни условия за ползване. Целта е професионални средства да са достъпни за ученици, студенти и млади специалисти.',
        },
      ],
      valuesTitle: 'Принципи на работа',
      values: [
        {
          title: 'Точност и надеждност',
          text: 'Изчисленията следват установени геодезически методи; интерфейсът е ясен и предвидим.',
        },
        {
          title: 'Свързаност на процесите',
          text: 'Единни инструменти за учебна зала и за терен — без разминаване между обучение и практика.',
        },
        {
          title: 'Практична стойност',
          text: 'Всяка функция решава конкретен проблем в учебния или работния процес.',
        },
        {
          title: 'Устойчиво развитие',
          text: 'Продуктът се развива от екипа на Wortexa в диалог с преподаватели и практикуващи специалисти.',
        },
      ],
      ctaTitle: 'Научете повече',
      ctaTeachers: 'За преподаватели',
      ctaStudents: 'За ученици и студенти',
      ctaContact: 'Контакти',
    },

    // For Teachers page
    forTeachersTitle: 'За преподаватели',
    forTeachersDescription:
      'Класна стая GeoSolver за преподаватели по геодезия: групи, задания, автоматична проверка и контрол върху калкулатора при решаване.',
    forTeachersHeadline: 'Класна стая за геодезия в училище',
    forTeachersIntro:
      'Създавайте групи, задавайте задачи с ясни входни данни и получавайте отговорите на учениците на едно място. Проверката е автоматична; вие решавате дали калкулаторът е разрешен за всяко задание.',
    forTeachersFeatures: [
      {
        title: 'Групи и код за присъединяване',
        desc: 'Учениците влизат с код — без отделни настройки за всеки профил в клас.',
      },
      {
        title: 'Задания с краен срок',
        desc: 'Задайте условие, очакван резултат и режим на калкулатора: изключен, само помощ или пълен достъп.',
      },
      {
        title: 'Автоматична проверка',
        desc: 'След предаване виждате резултат, грешки и опашка за преглед — без ръчно смятане на всяко решение.',
      },
      {
        title: 'Инструменти и документация',
        desc: 'Четирите основни геодезически задачи с кратка документация — подходящи за упражнения и контролни.',
      },
    ],
    forTeachersHowTitle: 'Как започвате',
    forTeachersSteps: [
      'Регистрирайте се и заявете преподавателски достъп (или използвайте акаунт, ако вече сте одобрени).',
      'Отворете класната стая, създайте група и споделете кода с учениците.',
      'Създайте задание — изберете инструмент, режим на калкулатор и краен срок.',
      'Прегледайте предадените отговори и маркирайте нуждаещите се от внимание.',
    ],
    forTeachersPlanFreeTitle: 'Класна стая',
    forTeachersPlanFreePrice: '0 лв',
    forTeachersPlanFreeNote: 'За преподаватели в България',
    forTeachersPlanFreeFeatures: [
      'Една група (до около 40 ученика)',
      'Неограничени задания в групата',
      'Автоматична проверка и код за група',
      'Режим на калкулатор по задание',
    ],
    forTeachersPlanProTitle: 'Класна стая Pro',
    forTeachersPlanProBadge: 'Пилот',
    forTeachersPlanProNote: 'За училища и курсове с повече групи — свържете се с нас.',
    forTeachersPlanProFeatures: [
      'Неограничени групи',
      'Експорт CSV и аналитика',
      'Шаблони за задания',
      'Приоритетна поддръжка',
    ],
    forTeachersPlanProCta: 'Заяви пилот',
    forTeachersStudentsNote:
      'Учениците в клас не се нуждаят от платен абонамент. За самостоятелна работа извън задание важат обикновените лимити на сайта.',
    forTeachersStudentsLink: 'Виж страницата за ученици',
    forTeachersOpenClassroom: 'Отвори класната стая',
    howToGetAccess: 'Преподавателски достъп',
    howToGetAccessText:
      'Ако сте регистрирани като ученик, подайте заявка по-долу. Можете и да ни пишете на',
    howToGetAccessHelp:
      'Ще прегледаме заявката и ще активираме роля „преподавател“, за да виждате класната стая.',
    howToGetAccessContact: 'Контакти',
    teacherRequestPlaceholder: 'Кратко съобщение (по избор): училище, предмет, брой часове…',
    forTeachersThanksTitle: 'Благодарим ви',
    forTeachersThanksP1:
      'Оценяваме всеки преподавател, който реши да опита GeoSolver в часовете си — вашата обратна връзка от реални групи ни помага да подобряваме класната стая и инструментите.',
    forTeachersThanksP2:
      'GeoSolver е създаден от геодезисти за геодезисти: познаваме задачите, допуските и ритъма на обучението, защото сме минали през същите изчисления в практиката и в зала.',
    forTeachersThanksP3:
      'Платформата е в ранен стадий (beta). Възможно е да срещнете грешки или неудобства — ще сме благодарни, ако ни ги съобщите, както и ако споделите идеи за подобрение.',
    forTeachersThanksContactBefore: 'Пишете ни чрез',
    forTeachersThanksContactAfter: 'или на team@geosolver.bg.',

    // For Students page
    forStudentsTitle: 'За ученици',
    forStudentsDescription:
      'Задания по геодезия от преподавателя: код за група, предаване на отговори и калкулатор само когато е разрешен.',
    forStudentsHeadline: 'Задания от учителя на едно място',
    forStudentsIntro:
      'Преподавателят ви дава код на група. Влизате, виждате заданията с краен срок и предавате решението. Калкулаторът на сайта се ползва само ако за това задание е разрешено — иначе смятате на тетрадка и въвеждате крайните стойности.',
    forStudentsFeatures: [
      {
        title: 'Код за група',
        desc: 'Един код от учителя — без отделни настройки за всеки в час.',
      },
      {
        title: 'Ясни задания',
        desc: 'Виждате условието, кои полета да попълните и до кога е крайният срок.',
      },
      {
        title: 'Калкулатор по правила',
        desc: 'Изключен, само помощ или пълен достъп — решава преподавателят за всяко задание.',
      },
      {
        title: 'Обратна връзка след предаване',
        desc: 'След предаване виждате дали сте в допуск и съвети от GAI какво да поправите.',
      },
    ],
    forStudentsHowTitle: 'Как да започнете',
    forStudentsSteps: [
      'Регистрирайте се (или влезте с акаунт).',
      'Отворете „Присъедини се с код“ и въведете кода от преподавателя.',
      'Изберете задание, решете според указанията и предайте отговора.',
      'Прегледайте резултата и обратната връзка — при нужда поправете преди крайния срок, ако учителят е разрешил.',
    ],
    forStudentsInClassTitle: 'В час с преподавател',
    forStudentsInClassDesc:
      'Предаванията в класната стая са безплатни и не изискват платен абонамент. Изчисления в рамките на разрешено задание не намаляват лимита от 5 свободни изчисления на инструментите.',
    forStudentsSelfStudyTitle: 'Самостоятелна практика',
    forStudentsSelfStudyDesc:
      'Извън задание от учител ползвате обикновените калкулатори на сайта — с безплатен лимит от 5 изчисления общо или с Pro абонамент.',
    forStudentsJoinCta: 'Присъедини се с код',
    forStudentsRegisterCta: 'Регистрация',
    forStudentsToolsCta: 'Инструменти за упражнение',
    forStudentsGaiLink: 'Научете повече за GAI',
    forStudentsTeachersLink: 'Информация за преподаватели',
    forStudentsNoteTitle: 'За платформата',
    forStudentsNoteP1:
      'GeoSolver е направен от геодезисти за геодезисти — за да улесни същите задачи, които решавате в курса.',
    forStudentsNoteP2:
      'Сайтът е в ранен стадий (beta). Ако забележите грешка, кажете ни през контактната форма — ще сме ви благодарни.',

    // GAI page
    gaiTitle: 'GAI',
    gaiDescription:
      'GAI в класната стая — обратна връзка по полета след предаване и преглед на класа за преподавателя.',
    gaiHeadline: 'Обратна връзка след предаване',
    gaiIntro:
      'GAI е помощникът на GeoSolver в класната стая. След като предадете задание, сравнява вашите стойности с очаквания отговор и обяснява къде сте в допуск, къде не — и какъв е вероятният пропуск (знак, единици, десетична запетая).',
    gaiAcronymNote: 'GAI = GeoSolver Artificial Intelligence',
    gaiFeatures: [
      {
        title: 'Резултат по полета',
        desc: 'За X₂, Y₂, ъгъл, разстояние и др. — ясно дали стойността е приета, близка или грешна.',
      },
      {
        title: 'Типични грешки',
        desc: 'Подсказва чести причини: объркан знак, грешка в поредността на величините, объркване ×10.',
      },
      {
        title: 'Поглед към класа',
        desc: 'Ученикът вижда анонимно обобщение спрямо групата. Преподавателят — статистика за цялото задание.',
      },
      {
        title: 'Четирите задачи',
        desc: 'Работи с първа и втора основна, права и обратна засечка — същите инструменти като в заданието.',
      },
    ],
    gaiForStudentsTitle: 'Ако сте ученик',
    gaiForStudentsIntro:
      'След предаване виждате процент и коментар по всяко поле. Понякога има и кратък съвет преди предаване, ако учителят е разрешил калкулатора.',
    gaiForStudentsPoints: [
      'Обратна връзка веднага след предаване',
      'Без показване на чужи лични отговори',
      'По избор — по-разговорно обяснение върху фактите',
    ],
    gaiForTeachersTitle: 'Ако сте преподавател',
    gaiForTeachersIntro:
      'В заданието виждате обобщение за класа: среден резултат, разпределение, най-чести грешки по поле и идеи за следващия час.',
    gaiForTeachersPoints: [
      'Анализ на всички предавания по задание',
      'GAI изводи при преглед на всяко решение',
      'По избор — кратък текстов преглед за часа',
    ],
    gaiHowTitle: 'Как работи',
    gaiHowSteps: [
      'Предавате решение — GeoSolver сравнява с очаквания отговор и допуска.',
      'GAI прилага правила за геодезия и описва грешките по поле.',
      'Ученикът вижда своята обратна връзка; преподавателят — и обобщение за групата.',
      'При нужда се добавя по-четим текст върху вече изчислените данни.',
    ],
    gaiLimitsTitle: 'Важно',
    gaiLimitsText:
      'GAI не решава задачите вместо вас и не дава оценка вместо преподавателя. Работи само в класната стая, при задания с автоматична проверка.',
    gaiCtaTeachers: 'Страница за преподаватели',
    gaiCtaStudents: 'Страница за ученици',

    // Scientific Calculator
    scientificCalculatorTitle: 'Научен калкулатор',
    scientificCalculatorDesc: 'Мощен научен калкулатор за сложни математически изрази, тригонометрия, логаритми, степени и още.',
    calcError: 'Грешка',
    calcHistory: 'История:',
    calcDocumentation: 'Документация',
    calcUsageExamples: 'Примери за използване:',
    calcBasicOps: 'Основни операции:',
    calcTrigonometry: 'Тригонометрия:',
    calcLogsPowers: 'Логаритми и степени:',
    calcSpecialFuncs: 'Специални функции:',
    calcKeyboardShortcuts: 'Клавиатурни съкращения:',
    calcBasicKeys: 'Основни клавиши:',
    calcSpecialKeys: 'Специални клавиши:',
    calcButton: 'Бутон',
    calcUsage: 'Употреба',
    calcDocRows: [
      { buttons: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], usage: 'Въвеждане на цифри (0-9)' },
      { buttons: ['+', '-', '*', '/'], usage: 'Основни операции: събиране (+), изваждане (-), умножение (*), деление (/)' },
      { buttons: ['='], usage: 'Получаване на резултата от изчисление (Enter)' },
      { buttons: ['C'], usage: 'Изчистване на екрана на калкулатора (Escape или C)' },
      { buttons: ['←'], usage: 'Изтриване на последния въведен символ (Backspace)' },
      { buttons: ['(', ')'], usage: 'Скоби за групиране на изрази и приоритет на операциите' },
      { buttons: ['.'], usage: 'Десетична точка за дробни числа' },
      { buttons: ['+/-'], usage: 'Промяна на знака на числото (позитивно/негативно)' },
      { buttons: ['%'], usage: 'Процент от число (например: 50% от 200 = 100)' },
      { buttons: [','], usage: 'Разделяне на аргументи на функции (например: log(10,2))' },
      { buttons: ['x^2', 'x^3', 'x^y', '10^x'], usage: 'Степенуване: квадрат, куб, произволна степен, 10 на степен x' },
      { buttons: ['√x', '³√x', 'y√x'], usage: 'Коренуване: квадратен корен, кубичен корен, корен от произволна степен' },
      { buttons: ['1/x'], usage: 'Обратно число (реципрочно: 1/x)' },
      { buttons: ['!'], usage: 'Факториел (n! = 1×2×3×...×n)' },
      { buttons: ['mod'], usage: 'Остатък от деление (modulo: a mod b)' },
      { buttons: ['nCr', 'nPr'], usage: 'Комбинаторика: комбинации (nCr) и пермутации (nPr)' },
      { buttons: ['π', 'e'], usage: 'Математически константи: π ≈ 3.14159, e ≈ 2.71828' },
      { buttons: ['sin', 'cos', 'tan', 'cot', 'sec', 'csc'], usage: 'Тригонометрични функции (според избрания режим: DEG/RAD/GRAD)' },
      { buttons: ['sinh', 'cosh', 'tanh'], usage: 'Хиперболични функции: хиперболичен синус, косинус, тангенс' },
      { buttons: ['asin', 'acos', 'atan', 'acot', 'asec', 'acsc'], usage: 'Обратни тригонометрични функции (аркус функции)' },
      { buttons: ['log', 'ln', 'exp'], usage: 'Логаритми: log (десетичен), ln (натурален), exp (експонента)' }
    ],
    calcDigits: 'Цифри',
    calcOperations: 'Операции',
    calcCalculate: 'Изчисли (=)',
    calcDelete: 'Изтрий (←)',
    calcClear: 'Изчисти (C)',
    calcParentheses: 'Скоби',
    calcDecimalPoint: 'Десетична точка',
    calcPercent: 'Процент',
    calcKeyPi: 'π (пи)',
    calcKeyE: 'e (експонента)',
    scientificCalculatorKeywords:
      'научен калкулатор, калкулатор, математика, тригонометрия, логаритми, степени, изчисления, GeoSolver',
    calcExampleBasic: [
      '• 2 + 3 * 4 = 14',
      '• (2 + 3) * 4 = 20',
      '• 10 / 2 + 5 = 10',
      '• 2^3 + 4^2 = 24',
    ],
    calcExampleBasicShort: [
      '• 2 + 3 * 4 = 14',
      '• (2 + 3) * 4 = 20',
      '• 10 / 2 + 5 = 10',
    ],
    calcExampleTrig: [
      '• sin(30) = 0.5 (в DEG режим)',
      '• cos(π/3) = 0.5 (в RAD режим)',
      '• tan(45) = 1',
      '• asin(0.5) = 30°',
    ],
    calcExampleTrigShort: [
      '• sin(30) = 0.5 (DEG режим)',
      '• cos(π/3) = 0.5 (RAD режим)',
      '• tan(45) = 1',
    ],
    calcExampleLogs: [
      '• log(100) = 2',
      '• ln(e) = 1',
      '• 10^2 = 100',
      '• √16 = 4',
    ],
    calcExampleSpecial: [
      '• 5! = 120',
      '• 10 mod 3 = 1',
      '• 1/4 = 0.25',
      '• π * 2 = 6.283',
    ],

    // Login page
    loginTitle: 'Вход',
    loginDescription: 'Влезте в своя GeoSolver акаунт за достъп до геодезически инструменти и изчисления.',
    welcomeTo: 'Добре дошли в',
    email: 'Имейл',
    password: 'Парола',
    enterEmail: 'Въведете имейла си',
    enterPassword: 'Въведете паролата си',
    rememberMe: 'Запомни ме',
    forgotPassword: 'Забравена парола',
    loginWithGoogle: 'Вход с Google',
    loggingIn: 'Вход...',
    or: 'или',
    successLogin: 'Успешен вход!',

    // Register page
    registerTitle: 'Регистрация',
    registerDescription: 'Създайте акаунт в GeoSolver за достъп до всички геодезически инструменти и изчисления.',
    fullName: 'Име и фамилия',
    enterFullName: 'Въведете вашето име и фамилия',
    enterYourEmail: 'Въведете вашият имейл',
    enterYourPassword: 'Въведете вашата парола',
    repeatPassword: 'Повтори паролата',
    repeatYourPassword: 'Повторете вашата парола',
    purposeQuestion: 'За какво ще използвате GeoSolver?',
    purposeStudent: 'За учебни цели',
    purposeTeacher: 'За преподаване',
    purposeWork: 'За работа',
    termsAgreement: 'Съгласен съм с общите условия и политиката за поверителност на GeoSolver.',
    termsAgreementPrefix: 'Съгласен съм с ',
    termsAgreementSuffix: ' на GeoSolver.',
    registerBtn: 'Регистрация',
    registering: 'Регистриране...',
    successRegister: 'Успешна регистрация!',
    alreadyHaveAccount: 'Вече имате акаунт?',

    // Forgot / Reset Password
    forgotPasswordTitle: 'Забравена парола',
    forgotPasswordDescription: 'Възстановяване на забравена парола за GeoSolver акаунт',
    forgotPasswordBannerSubline: 'Ще изпратим линк за възстановяване на имейла ви.',
    forgotPasswordHint: 'Въведете имейла, с който сте регистриран в GeoSolver.',
    forgotPasswordSuccessTitle: 'Проверете имейла си',
    forgotPasswordSuccessBody: 'Ако този имейл е регистриран, изпратихме инструкции за възстановяване. Линкът е валиден 30 минути.',
    sendResetLink: 'Изпрати линк',
    checkEmail: 'Провери имейла си за инструкции.',
    backToLogin: 'Обратно към вход',
    resetPasswordTitle: 'Нова парола',
    resetPasswordDescription: 'Задаване на нова парола за GeoSolver акаунт',
    resetPasswordBannerSubline: 'Задайте нова парола за акаунта си.',
    resetPasswordHint: 'Паролата трябва да е поне 6 символа. Линкът е валиден 30 минути.',
    resetNewPassword: 'Нова парола',
    resetConfirmPassword: 'Повтори новата парола',
    savingPassword: 'Записване...',
    passwordChangedSuccess: 'Паролата е сменена успешно!',
    redirectingToLogin: 'Пренасочване към вход...',
    invalidResetToken: 'Линкът е невалиден или изтекъл.',
    requestNewResetLink: 'Заяви нов линк',
    passwordsDoNotMatch: 'Паролите не съвпадат.',
    missingResetToken: 'Липсва токен за възстановяване.',
    confirmBtn: 'Потвърди',
    placeholderNames: 'Имена',

    // Admin Panel
    adminPanel: 'Администраторски панел',
    searchByNameOrEmail: 'Търси по име или имейл...',
    allRoles: 'Всички роли',
    student: 'Студент',
    teacher: 'Учител',
    administrator: 'Администратор',
    administratorShort: 'Админ',
    name: 'Име',
    role: 'Роля',
    registration: 'Регистрация',
    actions: 'Действия',
    noUsers: 'Няма потребители.',
    totalUsers: 'Общо потребители:',
    unknownTool: 'Неизвестен инструмент'
  },
  en: {
    // Header translations
    home: 'Home',
    tools: 'Tools',
    prices: 'Prices',
    about: 'About',
    contacts: 'Contacts',
    forTeachers: 'For Teachers',
    gai: 'GAI',
    fieldBooks: 'Field books',
    fieldBooksPilot: 'Pilot',
    account: 'Account',
    login: 'Login',
    logout: 'Logout',
    loading: 'Loading...',
    beta: 'BETA',

    // Footer translations
    quickLinks: 'Quick Links',
    privacyPolicy: 'Privacy Policy',
    terms: 'Terms & Conditions',
    disclaimer: 'Disclaimer',
    socialNetworks: 'Social Networks',
    language: 'English',
    theme: 'Light Mode',
    copyright: '© GEOSOLVER, 2025.\nAll rights reserved.\nCurrent version: v4.0.0-beta.1',
    wortexaFooterBefore: 'is part of the ',
    wortexaFooterAfter: ' product family',

    // FirstTask translations11
    firstTaskTitle: 'First Basic Task',
    firstTaskDescription: 'Calculate coordinates using initial point, angle, and distance with online geodetic calculator. Fast and accurate solutions for surveyors.',
    firstTaskKeywords: 'geodesy, online calculator, first basic task, coordinates, angle, distance, transformation, geodetic calculations',
    secondTaskTitle: 'Second Basic Task',
    secondTaskDescription:
      'Calculate distance and bearing between two points from coordinates with the online geodetic calculator.',
    secondTaskKeywords:
      'geodesy, second basic task, distance, bearing, coordinates, geodetic calculator',
    secondTaskDefaultResultText:
      'Enter coordinates and click "Calculate" to see results here.',
    forwardIntersectionDescription:
      'Forward intersection — determine point coordinates from two known points and angles.',
    forwardIntersectionKeywords:
      'geodesy, forward intersection, triangulation, coordinates, geodetic calculator',
    resectionDescription:
      'Resection — determine station position from directed clockwise angles at three known points.',
    resectionKeywords:
      'geodesy, resection, directed angles, coordinates, geodetic calculator',
    resectionDefaultResultText:
      'Enter the coordinates of the three points and the two directed clockwise angles, then click "Calculate".',
    fillAllFields: 'Please fill in all fields.',
    enterX1Short: 'Enter X₁',
    enterY1Short: 'Enter Y₁',
    enterX2Short: 'Enter X₂',
    enterY2Short: 'Enter Y₂',
    docsFirstTaskSeoDescription:
      'Documentation for the first basic geodetic task: theory, formulas, sign table, GeoSolver verification, and a worked example.',
    docsFirstTaskSeoKeywords:
      'first basic task, documentation, geodesy, formulas, gon, coordinates, GeoSolver',
    docsSecondTaskSeoDescription:
      'Documentation for the second basic task: inverse computation of distance and bearing, quadrants, and back-check.',
    docsSecondTaskSeoKeywords:
      'second basic task, documentation, inverse task, distance, bearing, GeoSolver',
    docsForwardIntersectionSeoDescription:
      'Documentation for forward intersection: law of sines, double determination of point P, angle constraints, and example.',
    docsForwardIntersectionSeoKeywords:
      'forward intersection, documentation, triangulation, geodesy, GeoSolver',
    docsResectionSeoDescription:
      'Documentation for resection: three control points, directed clockwise angles at station P, angle verification, and stability conditions.',
    docsResectionSeoKeywords:
      'resection, documentation, directed angles, danger circle, geodesy, GeoSolver',
    inputData: 'Input Data',
    results: 'Results',
    y1Coordinate: 'Y₁ (coordinate)',
    x1Coordinate: 'X₁ (coordinate)',
    angleAlpha: 'Angle α (in grads)',
    lengthS: 'Length S',
    enterY1: 'Enter Y1 coordinate',
    enterX1: 'Enter X1 coordinate',
    enterAlpha: 'Enter angle α',
    enterS: 'Enter length S',
    scan: 'Scan',
    reset: 'Reset',
    calculate: 'Calculate',
    scanInDevelopment: 'This feature is under development and integration.',
    defaultResultText: 'Enter data and click "Calculate" to see results here.',
    calculationHistory: 'Calculation History',
    noCalculations: 'No calculations.',
    date: 'Date',
    download: 'Download',
    documentation: 'Documentation',
    instrument: 'Instrument',
    back: 'Back',
    next: 'Next',

    // Homepage translations
    heroTitle: 'GeoSolver is a project born out of a desire to make the daily work of surveyors easier through an accessible online tool. The platform provides precise calculations, an intuitive interface and the ability to store calculation history.',
    heroSubtitle: 'Make your geodetic calculations quickly and easily with our online tools.',
    heroButton1: 'Get Started',
    heroButton2: 'Learn More',

    // Tools page translations
    toolsTitle: 'Tools',
    toolsDescription: 'Tools for coordinate calculations, intersections, transformations and area in geodesy.',
    toolsInDevelopment: 'Tools in Development',

    // Prices page translations
    pricesTitle: 'Prices and Plans',
    pricesDescription: 'Use GeoSolver for free with up to 5 calculations total or choose a professional subscription for unlimited access and additional features.',
    month: 'Month',
    year: 'Year (-20%)',
    freePlan: 'Free Plan',
    proPlan: 'Professional Plan',
    customPlan: 'Custom Plan',
    basicAccess: 'Basic access to all tools',
    fiveCalcsPerMonth: '5 calculations total',
    register: 'Register',
    recommended: 'Recommended',
    unlimitedCalcs: 'Unlimited calculations',
    prioritySupport: 'Priority support',
    additionalFeatures: 'Additional features',
    subscribe: 'Subscribe',
    customSolutions: 'Custom solutions',
    apiAccess: 'API access',
    contactUs: 'Contact us',
    faq: 'Frequently Asked Questions',

    // FirstTaskDocs translations
    firstTaskDocsTitle: 'First Basic Task in Coordinate Calculations',
    theory: 'Theory',
    theoryText: 'In many geodetic calculations, two basic tasks are used, which are called the first and second basic task or forward and inverse task.',
    firstTaskDefinition: 'The First Basic Task is determining the coordinates of point B (XB, YB), when given the coordinates of point A (XA, YA), the length of segment SAB, and the direction angle αAB (in grads).',
    given: 'Given:',
    givenPoints: [
      'YA, XA – coordinates of initial point A',
      'SAB – length of segment AB',
      'αAB – direction angle (in grads, 0g ≤ α ≤ 400g)'
    ],
    lookingFor: 'Looking for:',
    lookingForPoints: ['YB, XB'],
    formulas: 'Formulas',
    coordinateDifferences: 'ΔY and ΔX are called coordinate differences.',
    graphicalIllustration: 'Graphical Illustration',
    graphicCaption: 'According to Fig. 21.1, the coordinates of point B are:',
    signTable: 'Sign Table',
    directionAngle: 'Direction Angle',
    notes: 'Notes and Special Cases',
    notePoints: [
      'The direction angle αAB can be from 0 to 400g.',
      'The coordinate differences ΔYAB and ΔXAB are calculated using the trigonometric functions sin and cos for the given angle.',
      'The signs of ΔYAB and ΔXAB are determined by the table above.',
      'In electronic calculators, the formula with trigonometric functions is often used directly.'
    ],
    example: 'Example',

    // Account page translations
    accountTitle: 'Account',
    accountDescription: 'Your GeoSolver account, subscription, history and settings.',
    user: 'User',
    logoutFromAccount: 'Log out of account',
    settings: 'Settings',
    settingsPanel: {
      title: 'Settings',
      subtitle: 'Profile, appearance, security and preferences',
      backToAccount: 'Back to account',
      close: 'Close',
      sections: {
        profile: 'Profile',
        appearance: 'Appearance',
        security: 'Security',
        preferences: 'Preferences',
        privacy: 'Privacy',
      },
      profileDesc: 'Basic information for your GeoSolver account.',
      profileHint: 'To change your name or email, contact us at team@geosolver.bg.',
      nameLabel: 'Name',
      emailLabel: 'Email',
      roleLabel: 'Role',
      memberSince: 'Member since',
      appearanceDesc: 'Interface language and light/dark theme.',
      languageLabel: 'Language',
      langBg: 'Български',
      langEn: 'English',
      themeLabel: 'Theme',
      themeLight: 'Light',
      themeDark: 'Dark',
      securityDesc: 'Manage your password and account access.',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      savePassword: 'Save password',
      saving: 'Saving...',
      passwordFillAll: 'Please fill in all fields.',
      passwordMismatch: 'New passwords do not match.',
      passwordTooShort: 'Password must be at least 6 characters.',
      passwordSuccess: 'Password updated successfully.',
      passwordFailed: 'Failed to change password.',
      forgotPasswordLink: 'Forgot password?',
      googleSignInTitle: 'Signed in with Google',
      googleSignInDesc: 'This account uses Google sign-in. Password change is not available — manage access from your Google account.',
      preferencesDesc: 'Additional options for using the platform.',
      toolsInDevLabel: 'Tools in development',
      toolsInDevDesc: 'Shows menu items for tools not yet publicly released.',
      privacyDesc: 'Policies, cookies and legal information.',
      cookieReset: 'Change cookie choice',
      cookieResetHint: 'Reloads the page',
    },
    professionalPlanMonthly: 'Professional Plan (Monthly)',
    daysFromStart: 'days since the start of your plan',
    daysToNext: 'days until the next payment',
    changePlan: 'Change plan',
    manageSubscription: 'Manage subscription',
    paymentMethods: 'Payment Methods',
    remove: 'Remove',
    addNewMethod: 'Add new method',
    usageHistory: 'Usage History',
    calculations: 'calculations',
    tool: 'Tool',
    paymentHistory: 'Payment History',
    paymentMethod: 'Payment Method',
    value: 'Value',
    firstBasicTask: 'First Basic Task',
    secondBasicTask: 'Second Basic Task',
    forwardIntersection: 'Forward Intersection',
    resection: 'Resection',
    polarIntersection: 'Polar Intersection',
    coordinateTransformation: 'Coordinate Transformation',
    hansenTask: 'Hansen Task',
    areaCalculation: 'Area Calculation',
    distanceBearing: 'Distance & Bearing',
    
    // Checkout page translations
    checkoutTitle: 'Complete Order',
    checkoutSubtitle: 'You will be redirected to Stripe\'s secure checkout to complete payment',
    orderSummary: 'Order Summary',
    yearlyBilling: 'Yearly billing',
    monthlyBilling: 'Monthly billing',
    paymentDetails: 'Payment Details',
    cardNumber: 'Card Number',
    cardholderName: 'Cardholder Name',
    cardholderNamePlaceholder: 'John Doe',
    expiryDate: 'Expiry Date',
    completePayment: 'Complete Payment',
    payWithStripe: 'Pay with Stripe',
    processingPayment: 'Processing...',
    securePaymentNotice: 'Your data is protected with 256-bit SSL encryption',
    freePlanDefault: 'Free Plan (Default)',
    freeCalculationsUntil: 'free calculations total',
    viewPlans: 'View plans',

    // Contacts page
    contactsTitle: 'Contacts',
    contactsDescription: 'Contact the Wortexa team about GeoSolver — the platform we develop and maintain.',
    contactIntro: 'We are here for any questions.',
    contactEmail: 'team@geosolver.bg',
    emailLabel: 'Email',
    titleLabel: 'Title',
    contentLabel: 'Content',
    send: 'Send',
    sending: 'Sending...',
    errorOccurred: 'An error occurred.',
    errorSending: 'An error occurred while sending.',
    connectionTimeout: 'Connection timed out. Please try again or email team@geosolver.bg.',
    faqTitle: 'Frequently Asked Questions',
    faqQuestions: [
      { question: 'How are free calculations calculated?', answer: 'Each registered user gets 5 free calculations total.' },
      { question: 'What types of calculations does GeoSolver support?', answer: 'GeoSolver offers coordinate transformations, area, length and volume calculations, GNSS analysis and other tools.' },
      { question: 'What payment methods are available?', answer: 'We accept credit/debit card and PayPal payments.' },
      { question: 'Is my data secure?', answer: 'All data is stored encrypted and is not shared with third parties.' },
      { question: 'How can I subscribe?', answer: 'Choose a professional plan and follow the payment steps. After confirmation you will have unlimited access.' },
      { question: 'Is there a mobile version of GeoSolver?', answer: 'GeoSolver is designed specifically for use on small devices.' }
    ],

    // About page
    aboutPage: {
      seoTitle: 'About Us – GeoSolver',
      seoDescription:
        'GeoSolver — a Bulgarian digital platform for geodetic calculations, developed and maintained by the Wortexa team.',
      title: 'About us',
      headline: 'A digital platform for geodesy, education, and professional practice',
      intro:
        'GeoSolver is a Bulgarian software product for online geodetic calculations. We develop tools for teachers, students, and practicing surveyors — with a focus on accuracy, digitalization, and efficiency in daily work.',
      missionTitle: 'Mission',
      missionText:
        'To provide a reliable and accessible digital environment for geodetic calculations and learning — aligned with the requirements of education and professional practice.',
      companyTitle: 'Development and maintenance',
      companyTextBefore:
        'GeoSolver is developed and maintained by the ',
      companyTextAfter:
        ' team — the company behind the platform. We bring experience in engineering geodesy, education, and software products. The platform integrates calculators, a teacher classroom, and specialized modules into a single cloud ecosystem, accessible from any browser-enabled device.',
      companyLinkLabel: 'Wortexa',
      focusTitle: 'Core areas',
      focusAreas: [
        {
          title: 'Education',
          desc: 'GeoSolver Edu provides teachers with a classroom, assignments, automatic grading, and calculator access control. Tools are aligned with geodesy curricula.',
        },
        {
          title: 'Digitalization',
          desc: 'Moving to structured digital workflows reduces error risk and improves traceability of calculations — in education and in professional work.',
        },
        {
          title: 'Professional practice',
          desc: 'Calculators and modules cover standard geodetic tasks — from basic tasks and intersections to electronic field books and specialized tools.',
        },
        {
          title: 'Accessibility',
          desc: 'A free plan to explore the platform, bilingual interface, and clear terms of use. Professional tools should be available to students and young specialists.',
        },
      ],
      valuesTitle: 'Operating principles',
      values: [
        {
          title: 'Accuracy and reliability',
          text: 'Calculations follow established geodetic methods; the interface is clear and predictable.',
        },
        {
          title: 'Process continuity',
          text: 'Unified tools for the classroom and the field — without a gap between training and practice.',
        },
        {
          title: 'Practical value',
          text: 'Every feature addresses a specific need in the learning or work process.',
        },
        {
          title: 'Sustainable development',
          text: 'The product is developed by the Wortexa team in dialogue with teachers and practicing professionals.',
        },
      ],
      ctaTitle: 'Learn more',
      ctaTeachers: 'For teachers',
      ctaStudents: 'For students',
      ctaContact: 'Contact',
    },

    // For Teachers page
    forTeachersTitle: 'For Teachers',
    forTeachersDescription:
      'GeoSolver classroom for geodesy teachers: groups, assignments, auto-grading, and per-task calculator control.',
    forTeachersHeadline: 'Classroom for geodesy at school',
    forTeachersIntro:
      'Create groups, assign tasks with clear inputs, and collect student submissions in one place. Grading is automatic; you decide whether the calculator is allowed for each assignment.',
    forTeachersFeatures: [
      {
        title: 'Groups and join code',
        desc: 'Students join with a code — no per-device setup in class.',
      },
      {
        title: 'Assignments with deadlines',
        desc: 'Set the problem, expected result, and calculator mode: off, guided, or full access.',
      },
      {
        title: 'Automatic checking',
        desc: 'After submission you see score, errors, and a review queue — without hand-checking every solution.',
      },
      {
        title: 'Tools and documentation',
        desc: 'Four core geodetic tasks with short docs — suitable for exercises and tests.',
      },
    ],
    forTeachersHowTitle: 'How to get started',
    forTeachersSteps: [
      'Register and request teacher access (or sign in if already approved).',
      'Open the classroom, create a group, and share the code with students.',
      'Create an assignment — pick a tool, calculator mode, and due date.',
      'Review submissions and flag students who need follow-up.',
    ],
    forTeachersPlanFreeTitle: 'Classroom',
    forTeachersPlanFreePrice: '€0',
    forTeachersPlanFreeNote: 'For teachers in Bulgaria',
    forTeachersPlanFreeFeatures: [
      'One group (up to ~40 students)',
      'Unlimited assignments in the group',
      'Auto-grading and group code',
      'Calculator mode per assignment',
    ],
    forTeachersPlanProTitle: 'Classroom Pro',
    forTeachersPlanProBadge: 'Pilot',
    forTeachersPlanProNote: 'For schools and courses with multiple groups — contact us.',
    forTeachersPlanProFeatures: [
      'Unlimited groups',
      'CSV export and analytics',
      'Assignment templates',
      'Priority support',
    ],
    forTeachersPlanProCta: 'Request pilot',
    forTeachersStudentsNote:
      'Students in class do not need a paid subscription. For self-study outside assignments, normal site limits apply.',
    forTeachersStudentsLink: 'See the page for students',
    forTeachersOpenClassroom: 'Open classroom',
    howToGetAccess: 'Teacher access',
    howToGetAccessText:
      'If you registered as a student, submit a request below. You can also email us at',
    howToGetAccessHelp:
      'We will review your request and enable the teacher role so you can use the classroom.',
    howToGetAccessContact: 'Contact',
    teacherRequestPlaceholder: 'Short message (optional): school, subject, class size…',
    forTeachersThanksTitle: 'Thank you',
    forTeachersThanksP1:
      'We appreciate every teacher who tries GeoSolver in class — your feedback from real groups helps us improve the classroom and our tools.',
    forTeachersThanksP2:
      'GeoSolver is built by geodesists for geodesists: we know the tasks, tolerances, and pace of teaching because we have worked through the same calculations in practice and in the classroom.',
    forTeachersThanksP3:
      'The platform is in an early stage (beta). You may run into bugs or rough edges — we would be grateful if you report them and share ideas for improvement.',
    forTeachersThanksContactBefore: 'Reach us via the',
    forTeachersThanksContactAfter: 'or at team@geosolver.bg.',

    // For Students page
    forStudentsTitle: 'For students',
    forStudentsDescription:
      'Geodesy assignments from your teacher: group code, submit answers, calculator only when allowed.',
    forStudentsHeadline: 'Teacher assignments in one place',
    forStudentsIntro:
      'Your teacher gives you a group code. You sign in, see assignments with due dates, and submit your solution. Use the site calculator only when that assignment allows it — otherwise work on paper and enter final values.',
    forStudentsFeatures: [
      {
        title: 'Group code',
        desc: 'One code from your teacher — no per-device setup in class.',
      },
      {
        title: 'Clear assignments',
        desc: 'See the problem, which fields to fill, and the deadline.',
      },
      {
        title: 'Calculator rules',
        desc: 'Off, guided, or full access — your teacher decides per assignment.',
      },
      {
        title: 'Feedback after submit',
        desc: 'After submitting, see if you are within tolerance and GAI tips on what to fix.',
      },
    ],
    forStudentsHowTitle: 'How to get started',
    forStudentsSteps: [
      'Register (or sign in).',
      'Open “Join with code” and enter your teacher’s code.',
      'Pick an assignment, solve as instructed, and submit.',
      'Review your result and feedback — resubmit before the deadline if your teacher allows it.',
    ],
    forStudentsInClassTitle: 'In class with your teacher',
    forStudentsInClassDesc:
      'Classroom submissions are free and do not require a paid plan. Calculations within an allowed assignment do not use your 5 free tool calculations.',
    forStudentsSelfStudyTitle: 'Self-study practice',
    forStudentsSelfStudyDesc:
      'Outside teacher assignments, use the site calculators — 5 free calculations total or a Pro subscription.',
    forStudentsJoinCta: 'Join with code',
    forStudentsRegisterCta: 'Register',
    forStudentsToolsCta: 'Practice tools',
    forStudentsGaiLink: 'Learn more about GAI',
    forStudentsTeachersLink: 'Information for teachers',
    forStudentsNoteTitle: 'About the platform',
    forStudentsNoteP1:
      'GeoSolver is built by geodesists for geodesists — to make the same tasks you study easier to practice.',
    forStudentsNoteP2:
      'The site is in an early stage (beta). If you spot a bug, tell us via the contact form — we appreciate it.',

    // GAI page
    gaiTitle: 'GAI',
    gaiDescription:
      'GAI in the classroom — field-level feedback after submit and class overview for teachers.',
    gaiHeadline: 'Feedback after you submit',
    gaiIntro:
      'GAI is GeoSolver’s assistant in the classroom. After you submit an assignment, it compares your values to the expected answer and explains what is within tolerance, what is not — and the likely slip-up (sign, units, decimal place).',
    gaiAcronymNote: 'GAI = GeoSolver Artificial Intelligence',
    gaiFeatures: [
      {
        title: 'Results per field',
        desc: 'For X₂, Y₂, angle, distance, etc. — clearly accepted, close, or wrong.',
      },
      {
        title: 'Typical mistakes',
        desc: 'Hints at common causes: sign errors, swapped values, ×10 decimal mistakes.',
      },
      {
        title: 'Class context',
        desc: 'Students see anonymous group summary. Teachers get stats for the whole assignment.',
      },
      {
        title: 'Four task types',
        desc: 'Works with first and second basic tasks, forward and resection — same as in assignments.',
      },
    ],
    gaiForStudentsTitle: 'If you are a student',
    gaiForStudentsIntro:
      'After submit you see a score and comments per field. Sometimes a short hint appears before submit if your teacher allowed the calculator.',
    gaiForStudentsPoints: [
      'Feedback right after submission',
      'No other students’ personal answers shown',
      'Optional — clearer wording on top of the facts',
    ],
    gaiForTeachersTitle: 'If you are a teacher',
    gaiForTeachersIntro:
      'On the assignment you see a class summary: average, distribution, common field errors, and ideas for the next lesson.',
    gaiForTeachersPoints: [
      'Analytics across all submissions for one assignment',
      'GAI notes when reviewing each solution',
      'Optional — short narrative for planning class',
    ],
    gaiHowTitle: 'How it works',
    gaiHowSteps: [
      'You submit — GeoSolver compares to the expected answer and tolerance.',
      'GAI applies geodesy rules and describes errors per field.',
      'The student sees personal feedback; the teacher sees group summary too.',
      'When needed, readable text is added on top of computed data.',
    ],
    gaiLimitsTitle: 'Important',
    gaiLimitsText:
      'GAI does not solve tasks for you and does not grade instead of the teacher. It only works in the classroom for auto-checked assignments.',
    gaiCtaTeachers: 'Page for teachers',
    gaiCtaStudents: 'Page for students',

    // Scientific Calculator
    scientificCalculatorTitle: 'Scientific Calculator',
    scientificCalculatorDesc: 'Powerful scientific calculator for complex mathematical expressions, trigonometry, logarithms, powers and more.',
    calcError: 'Error',
    calcHistory: 'History:',
    calcDocumentation: 'Documentation',
    calcUsageExamples: 'Usage examples:',
    calcBasicOps: 'Basic operations:',
    calcTrigonometry: 'Trigonometry:',
    calcLogsPowers: 'Logarithms and powers:',
    calcSpecialFuncs: 'Special functions:',
    calcKeyboardShortcuts: 'Keyboard shortcuts:',
    calcBasicKeys: 'Basic keys:',
    calcSpecialKeys: 'Special keys:',
    calcButton: 'Button',
    calcUsage: 'Usage',
    calcDocRows: [
      { buttons: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], usage: 'Enter digits (0-9)' },
      { buttons: ['+', '-', '*', '/'], usage: 'Basic operations: addition (+), subtraction (-), multiplication (*), division (/)' },
      { buttons: ['='], usage: 'Get calculation result (Enter)' },
      { buttons: ['C'], usage: 'Clear calculator display (Escape or C)' },
      { buttons: ['←'], usage: 'Delete last entered character (Backspace)' },
      { buttons: ['(', ')'], usage: 'Parentheses for grouping expressions and operation priority' },
      { buttons: ['.'], usage: 'Decimal point for fractional numbers' },
      { buttons: ['+/-'], usage: 'Change number sign (positive/negative)' },
      { buttons: ['%'], usage: 'Percentage of number (e.g.: 50% of 200 = 100)' },
      { buttons: [','], usage: 'Separate function arguments (e.g.: log(10,2))' },
      { buttons: ['x^2', 'x^3', 'x^y', '10^x'], usage: 'Powers: square, cube, arbitrary power, 10 to the power of x' },
      { buttons: ['√x', '³√x', 'y√x'], usage: 'Roots: square root, cube root, root of arbitrary degree' },
      { buttons: ['1/x'], usage: 'Reciprocal (1/x)' },
      { buttons: ['!'], usage: 'Factorial (n! = 1×2×3×...×n)' },
      { buttons: ['mod'], usage: 'Remainder of division (modulo: a mod b)' },
      { buttons: ['nCr', 'nPr'], usage: 'Combinatorics: combinations (nCr) and permutations (nPr)' },
      { buttons: ['π', 'e'], usage: 'Mathematical constants: π ≈ 3.14159, e ≈ 2.71828' },
      { buttons: ['sin', 'cos', 'tan', 'cot', 'sec', 'csc'], usage: 'Trigonometric functions (depending on mode: DEG/RAD/GRAD)' },
      { buttons: ['sinh', 'cosh', 'tanh'], usage: 'Hyperbolic functions: hyperbolic sine, cosine, tangent' },
      { buttons: ['asin', 'acos', 'atan', 'acot', 'asec', 'acsc'], usage: 'Inverse trigonometric functions (arc functions)' },
      { buttons: ['log', 'ln', 'exp'], usage: 'Logarithms: log (decimal), ln (natural), exp (exponential)' }
    ],
    calcDigits: 'Digits',
    calcOperations: 'Operations',
    calcCalculate: 'Calculate (=)',
    calcDelete: 'Delete (←)',
    calcClear: 'Clear (C)',
    calcParentheses: 'Parentheses',
    calcDecimalPoint: 'Decimal point',
    calcPercent: 'Percent',
    calcKeyPi: 'π (pi)',
    calcKeyE: 'e (Euler\'s number)',
    scientificCalculatorKeywords:
      'scientific calculator, calculator, math, trigonometry, logarithms, powers, calculations, GeoSolver',
    calcExampleBasic: [
      '• 2 + 3 * 4 = 14',
      '• (2 + 3) * 4 = 20',
      '• 10 / 2 + 5 = 10',
      '• 2^3 + 4^2 = 24',
    ],
    calcExampleBasicShort: [
      '• 2 + 3 * 4 = 14',
      '• (2 + 3) * 4 = 20',
      '• 10 / 2 + 5 = 10',
    ],
    calcExampleTrig: [
      '• sin(30) = 0.5 (in DEG mode)',
      '• cos(π/3) = 0.5 (in RAD mode)',
      '• tan(45) = 1',
      '• asin(0.5) = 30°',
    ],
    calcExampleTrigShort: [
      '• sin(30) = 0.5 (DEG mode)',
      '• cos(π/3) = 0.5 (RAD mode)',
      '• tan(45) = 1',
    ],
    calcExampleLogs: [
      '• log(100) = 2',
      '• ln(e) = 1',
      '• 10^2 = 100',
      '• √16 = 4',
    ],
    calcExampleSpecial: [
      '• 5! = 120',
      '• 10 mod 3 = 1',
      '• 1/4 = 0.25',
      '• π * 2 = 6.283',
    ],

    // Login page
    loginTitle: 'Login',
    loginDescription: 'Sign in to your GeoSolver account for access to geodetic tools and calculations.',
    welcomeTo: 'Welcome to',
    email: 'Email',
    password: 'Password',
    enterEmail: 'Enter your email',
    enterPassword: 'Enter your password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password',
    loginWithGoogle: 'Sign in with Google',
    loggingIn: 'Logging in...',
    or: 'or',
    successLogin: 'Login successful!',

    // Register page
    registerTitle: 'Register',
    registerDescription: 'Create a GeoSolver account for access to all geodetic tools and calculations.',
    fullName: 'Full name',
    enterFullName: 'Enter your full name',
    enterYourEmail: 'Enter your email',
    enterYourPassword: 'Enter your password',
    repeatPassword: 'Repeat password',
    repeatYourPassword: 'Repeat your password',
    purposeQuestion: 'What will you use GeoSolver for?',
    purposeStudent: 'For studying',
    purposeTeacher: 'For teaching',
    purposeWork: 'For work',
    termsAgreement: 'I agree to GeoSolver\'s terms and conditions and privacy policy.',
    termsAgreementPrefix: 'I agree to ',
    termsAgreementSuffix: ' of GeoSolver.',
    registerBtn: 'Register',
    registering: 'Registering...',
    successRegister: 'Registration successful!',
    alreadyHaveAccount: 'Already have an account?',

    // Forgot / Reset Password
    forgotPasswordTitle: 'Forgot Password',
    forgotPasswordDescription: 'Recover forgotten password for GeoSolver account',
    forgotPasswordBannerSubline: 'We will email you a link to reset your password.',
    forgotPasswordHint: 'Enter the email you used to register on GeoSolver.',
    forgotPasswordSuccessTitle: 'Check your email',
    forgotPasswordSuccessBody: 'If this email is registered, we sent reset instructions. The link is valid for 30 minutes.',
    sendResetLink: 'Send reset link',
    checkEmail: 'Check your email for instructions.',
    backToLogin: 'Back to login',
    resetPasswordTitle: 'New password',
    resetPasswordDescription: 'Set a new password for your GeoSolver account',
    resetPasswordBannerSubline: 'Set a new password for your account.',
    resetPasswordHint: 'Password must be at least 6 characters. The link is valid for 30 minutes.',
    resetNewPassword: 'New password',
    resetConfirmPassword: 'Confirm new password',
    savingPassword: 'Saving...',
    passwordChangedSuccess: 'Password changed successfully!',
    redirectingToLogin: 'Redirecting to login...',
    invalidResetToken: 'This link is invalid or has expired.',
    requestNewResetLink: 'Request a new link',
    passwordsDoNotMatch: 'Passwords do not match.',
    missingResetToken: 'Missing reset token.',
    confirmBtn: 'Confirm',
    placeholderNames: 'Name',

    // Admin Panel
    adminPanel: 'Admin Panel',
    searchByNameOrEmail: 'Search by name or email...',
    allRoles: 'All roles',
    student: 'Student',
    teacher: 'Teacher',
    administrator: 'Administrator',
    administratorShort: 'Admin',
    name: 'Name',
    role: 'Role',
    registration: 'Registration',
    actions: 'Actions',
    noUsers: 'No users.',
    totalUsers: 'Total users:',
    unknownTool: 'Unknown tool'
  }
};